import React from 'react';

const DescriptionTab = ({ description }: { description: string }) => {
  return (
    <div className="product-tab-content">
      {description.split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </div>
  );
};


export default DescriptionTab;
